import React from 'react';

import {BsArrowRight} from 'react-icons/bs';

import {motion} from 'framer-motion';

import {fadeIn} from '../variants';


const services = [
  {
    name:"Programming",
    desc:"C++, Python, Javascript, SQL, Rust",
    link:'learn more'
  },
  {
    name:"Python Frameworks",
    desc:"Numpy, Pandas, Matplotlib, Scikit, Scipy",
    link:'learn more'
  },
  {
    name:"Web Development",
    desc:"React, Angular, Node, Express, MongoDB, Postgres, React Native",
    link:'learn more'
  },{
    name:"Developer Tools",
    desc:"GitHub, VS Code, Docker, Kubernetes, Figma, Google Cloud Platform, Android Studio",
    link:'learn more'
  },{
    name:"Other",
    desc:"Operating System(Windows, Linux), Networking, Data Visualization",
    link:'learn more'
  }

]


const Services = () => {
  return(  
  <section id="Services" className="section mt-60 mb-0 lg:mt-20 lg:mb-60">
    <div className='container mx-auto  mt-40'>
      <div className="flex flex-col lg:flex-row">
        <motion.div
          variants={fadeIn('right',0.3)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
          className="flex-1 h-[600px] lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0">
          <h1 className="h1 text-fuchsia-600 text-[60px] mb-6">Skills</h1>
          <a href="https://asprojects.netlify.app/" target='_blank'>
          <button className="btn btn-sm m-0">See my Projects</button>
          </a>
        </motion.div>

        <div>
          <div>
            {services.map((service,index) => {
              const {name,desc,link}=service;
              return(
              <motion.div
                variants={fadeIn('left',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
                className="border-b border-white/20 h-[146px] mb-[38px] flex" key={index}>
                <div className="max-w-[470px]">
                  <h4 className="text-[20px] tracking-wider font-primary font-semibolde mb-6">{name}</h4>
                  <p className="font-secondary leading-tight">{desc}</p>
                </div>
                <div className="flex flex-col flex-1 items-end">
                  <a href="https://www.linkedin.com/in/arun2003as" className="btn w-5 h-5"><BsArrowRight/></a>
                  <a href="https://www.linkedin.com/in/arun2003as">{link}</a>
                </div>  
              </motion.div>)
            })}
          </div>
        </div>
      </div>
    </div>
  </section>);
};

export default Services;
